export default {
  exportKttPrint: require("./export-print").default,
  exportKtt: require("./export").default,
};
